export default {
  props: {
    src: {
      type: String,
    },

    alt: {
      type: String,
    },

    title: {
      type: String,
    },

    width: {
      type: String,
    },

    height: {
      type: String,
    },

    margins: {
      type: Object,
    },

    transparent: {
      type: Boolean,
      default: false,
    },

    withoutLazyload: {
      type: Boolean,
      default: false,
    },

    aspectRatio: {
      type: String,
      default: '',
    },

    srcsetDesktop: {
      type: String,
    },

    srcsetTablet: {
      type: String,
    },

    srcsetMobile: {
      type: String,
    },
  },

  data: function () {
    return {
      overflow: this.margins ? this.margins.overflow : false,
      m_top: this.margins ? this.margins.top : '',
      m_bottom: this.margins ? this.margins.bottom : '',
      m_left: this.margins ? this.margins.left : '',
      m_right: this.margins ? this.margins.right : '',
    }
  },

  computed: {
    cssProps() {
      if (this.margins) {
        var negative = this.overflow == true ? '-1' : '1'

        return `margin-top: ${this.m_top * negative}px;
        margin-bottom: ${this.m_bottom * negative}px;
        margin-left: ${this.m_left * negative}px;
        margin-right: ${this.m_right * negative}px;`
      }
    },

    transparentClasses() {
      if (this.transparent) return 'image--transparent'
    },

    aspectRatioClasses() {
      if (this.aspectRatio) return `aspect-ratio--${this.aspectRatio}`
    },
  },
}
